export default "__VITE_ASSET__DacdI4Ys__"